import React from 'react';
import { motion } from 'framer-motion';
import { Moon } from 'lucide-react';
export function HookSection() {
  return <section className="bg-cream py-20 px-6" data-id="element-127">
      <div className="max-w-3xl mx-auto text-center" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-129">
          <div className="flex justify-center mb-6" data-id="element-130">
            <Moon className="w-10 h-10 text-gold" strokeWidth={1.5} data-id="element-131" />
          </div>
          <p className="text-2xl md:text-3xl font-serif italic text-navy leading-relaxed" data-id="element-132">
            "Son las 2:45 AM. Tienes a tu bebé en brazos, caminas por el pasillo
            balanceándote mecánicamente y sientes que tus ojos pesan una
            tonelada. El miedo a que se despierte en cuanto su espalda toque el
            colchón es real, porque ya ha pasado tres veces esta noche."
          </p>
          <div className="w-24 h-px bg-gold/50 mx-auto my-10" data-id="element-133"></div>
          <p className="text-lg md:text-xl text-navy/80 font-medium leading-relaxed" data-id="element-134">
            No eres una mala madre por sentir furia o desesperación en este
            momento. Estás agotada. Estás sola en un país donde la ayuda es cara
            y los consejos de "déjalo llorar" simplemente no resuenan con tu
            corazón.
          </p>
        </motion.div>
      </div>
    </section>;
}